var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.61,
    height: 21.89,
    viewBox: "0 0 21.61 21.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4598",
    "data-name": "Group 4598",
    transform: "translate(-1729.04 -89.17)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    x2: 0.8,
    y2: 0.64,
    transform: "translate(1736.5 100.76)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-2",
    x2: 0.95,
    y2: 0.77,
    transform: "translate(1732.27 97.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4597",
    "data-name": "Group 4597"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(1734.27 98.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(1728.02 88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    d: "M13.67,9.33A1.67,1.67,0,1,1,12,7.66h0A1.673,1.673,0,0,1,13.67,9.33Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    d: "M8.65,15.7a3.185,3.185,0,0,1,3.34-2.94,3.185,3.185,0,0,1,3.34,2.94,8.9,8.9,0,0,1-6.69,0h0Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1738.539 89.77)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1745.659 96.36)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1729.64 104.72)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1738.3 107.46)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1747.05 106.7)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1729.64 94.84)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    y1: 1.92,
    x2: 4.27,
    transform: "translate(1732.399 103.7)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    y2: 2.74,
    transform: "translate(1740.039 92.76)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.89
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    y2: 3.12,
    transform: "translate(1739.8 104.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    x1: 3.41,
    y2: 2.4,
    transform: "translate(1742.08 99)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    x2: 3.8,
    y2: 3.33,
    transform: "translate(1743.359 103.7)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelWhiteIcon);
export default __webpack_public_path__ + "static/media/channel-white-icon.0217b5c1b8b912490951dc659f136939.svg";
export { ForwardRef as ReactComponent };